import { render } from "./DocumentGeneration.vue?vue&type=template&id=377d05a3&scoped=true"
import script from "./DocumentGeneration.vue?vue&type=script&lang=js"
export * from "./DocumentGeneration.vue?vue&type=script&lang=js"

import "./DocumentGeneration.vue?vue&type=style&index=0&id=377d05a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377d05a3"]])

export default __exports__